import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './my-site-product-bundles.html';
import { getCachedConfiguration } from "@nuskin/configuration-sdk";


export class MySiteProductBundles extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-product-bundles';
    }

    static get properties() {
        return {
            bundles: {
                type: Array,
                value: [],
                observer: '_handleBundles'
            },
            _bundleTranslations: {
                type: Object,
                value: {}
            },
            bundlesInfo: {
                type: Array,
                value:[]
            },
            forMySitePreview: {
                type: Boolean
            },
            priceType: {
                type: String
            }
        }
    }

    _handleBundles(newVal) {
        if(newVal && newVal.length && newVal[0].skus) {

            let data = newVal.map(bundle => {
                return {
                    id: bundle.id,
                    skus: bundle.skus ? bundle.skus.map(i => {
                        return {SKU: i};
                    }) : []
                };
            })
                .filter(item => item.skus.length);

            this.set('formattedBundles', data);
        } else
            this.set('formattedBundles', []);
    }

    getTitle(bundle) {
        if(this.bundlesInfo && this.bundlesInfo.length) {
            let info = this.bundlesInfo.find(item => {
                return item ? item.bundle_id === bundle.id : {}
            });
            return info ? info.name : (this._bundleTranslations.title || '');
        }
        return this._bundleTranslations.title || '';
    }
    getCategoryId(bundle) {
        if(this.bundlesInfo && this.bundlesInfo.length) {
            let info = this.bundlesInfo.find(item => {
                return item ? item.bundle_id === bundle.id : {}
            });
            return info ? info.bundle_id : (this._bundleTranslations.title || '');
        }
        return this._bundleTranslations.title || '';
    }

    getAbout(bundle) {
        if(this.bundlesInfo && this.bundlesInfo.length) {
            let info = this.bundlesInfo.find(item => {
                return item ? item.bundle_id === bundle.id : {}
            });
            return info ? info.about : (this._bundleTranslations.defaultBundleMessage || '');
        }
        return this._bundleTranslations.defaultBundleMessage || '';
    }

    ready() {
        super.ready();
        this.set('basePath', window.location.pathname);
        const MySiteConfig = getCachedConfiguration("Equinox_Markets")
        this.set('showMySiteCategories', MySiteConfig.MySite_Categories);
        console.log(`Showing My Site Categories ${MySiteConfig.MySite_Categories}`)

        // Initialize Slick Slider
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
        document.head.appendChild(script);

    }

}

window.customElements.define(MySiteProductBundles.is, MySiteProductBundles);